export const mapRecipeChipKeyToLabel = (key, short = true) => {
  switch (key) {
    case 'calories':
      return 'Calories'
    case 'carbohydrates':
      return 'Carbs'
    case 'fat':
      return 'Fat'
    case 'protein':
      return 'Protein'
    case 'sugar':
      return 'Sugar'
    case 'ofWhichSugars':
      return 'Sugar'
    case 'fibre':
      return 'Fibre'
    case 'energy (kJ)':
      return short ? 'Energy' : 'Energy (kJ)'
    case 'energy (kcal)':
      return short ? 'Energy' : 'Energy (kcal)'
    case 'ofWhichSaturates':
      return 'Saturates'
    case 'salt':
      return 'Salt'
    case 'totalFat':
      return 'Fat'
    case 'carbonEmissions':
      return 'Carbon'
    case 'grossProfit':
      return 'GP'
    case 'grossProfitPercentage':
      return 'GP %'
    case 'totalGrossProfit':
      return 'TGP'
    case 'totalGrossProfitPercentage':
      return 'TGP %'
    default:
      return key
  }
}

export const mapStepDataToFormData = step => {
  return {
    equipmentType: {
      id: step.stepEquipment[0] ? step.stepEquipment[step.stepEquipment.length - 1].equipment.id : null,
      time: step.stepEquipment[0] ? step.stepEquipment[step.stepEquipment.length - 1].timeInMins : null,
    },
    jobType: {
      id: step.stepJobType[0] ? step.stepJobType[step.stepJobType.length - 1].jobType.id : null,
      time: step.stepJobType[0] ? step.stepJobType[step.stepJobType.length - 1].timeInMins : null,
    },
    text: step.description,
    id: step.id,
    photo: step.photo,
    position: step.position,
  }
}

export const mapIngredientDataToFormData = ingredient => {
  return {
    ingredientId: ingredient.ingredient.id,
    ingredientName: ingredient.ingredient.name,
    ingredientType: ingredient.ingredientType,
    ingredientUnit: ingredient.ingredient.unit,
    quantity: ingredient.ingredientAmount,
  }
}

export const generateExtraChips = recipe => {
  const extraChips = {}

  if (recipe.carbonEmissions !== undefined && recipe.carbonEmissions > 0) {
    extraChips['carbonEmissions'] = {
      unit: ' kg CO2e',
      value: recipe.carbonEmissions,
    }
  }

  if (
    recipe.totalGrossProfitPercentage.value !== undefined &&
    recipe.totalGrossProfitPercentage.value !== null
  ) {
    extraChips['totalGrossProfitPercentage'] = {
      unit: '',
      value: `${recipe.totalGrossProfitPercentage.value}`,
    }
  }

  if (
    recipe.grossProfitPercentage.value !== undefined &&
    recipe.grossProfitPercentage.value !== null
  ) {
    extraChips['grossProfitPercentage'] = {
      unit: '',
      value: `${recipe.grossProfitPercentage.value}`,
    }
  }

  if (recipe.carbonEmmissons !== null && recipe.carbonEmmissons !== undefined) {
    extraChips['carbonEmissions'] = {
      unit: '',
      value: `${recipe.carbonEmissions}`,
    }
  }

  return extraChips
}

export const stepIsEmpty = step => {
  return !(
    step.id ||
    step.step ||
    step.jobType ||
    step.jobTypeTime ||
    step.equipmentType ||
    step.equipmentTypeTime ||
    step.stepPhoto
  )
}
